import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import {makeStyles, useTheme, withStyles} from "@mui/styles";
import ScreenLockPortraitTwoToneIcon from "@mui/icons-material/ScreenLockPortraitTwoTone";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import ChooseMobile from "./components/LoginWithToken/ChooseMobile";
import LoginUser from "./components/LoginWithToken/LoginUser";
import axios from "axios";
import { defaultVariables } from "../../../config";
import Grid from "@mui/material/Grid2";
import AppAnimate from "../../components/AppAnimate";
import {connect, getStore, setStore} from "trim-redux";
import AppCard from "../../components/layout/components/AppCard";
import {Styles} from "../../../config/design/styles";
import {useTranslation} from "react-i18next";
import LoginUserWithPass from "./components/LoginWithToken/LoginUserWithPass";
import Logo from "../../components/elements/Logo";
import Title from "../../components/elements/Title";
import {removeLocalStorages, whereShouldGoAfterLogin} from "../../../config/values";
import MakePassword from "../manage/users/MakePassword";



const ResetPassword = ({classes}) => {

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('loginRegister')}>
            <div className={classes.authContentInner}>
                <AppCard
                    title={
                        <Logo old_logo parentStyle={{textAlign:"center",width:'100%'}} style={{width:150}}/>
                    }
                >
                    <Grid container spacing={2} justifyContent={"center"} style={{minWidth:400}}>
                        <Grid item size={{xs:11}} style={{marginTop:20,marginBottom:10}}>
                            <Title color="field" align="left">{t("new_password")}</Title>
                        </Grid>
                        <Grid item size={11}>
                            <MakePassword reset/>
                        </Grid>
                    </Grid>
                </AppCard>
            </div>
        </AppAnimate>
    );
};
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(ResetPassword));
